// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:767px){.author-page[data-v-7b9e9603]{margin-top:50px}}", ""]);
// Exports
module.exports = exports;
